import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getTownList(params) {
  return request({
    url: URL.mdm.basicData.towns,
    method: 'get',
    params
  })
}

export function saveTown(data) {
  return request({
    url: URL.mdm.basicData.towns,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delTown(uuid) {
  return request({
    url: URL.mdm.basicData.towns + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

// 查询 区下 所有街道（乡镇）
export function getTownByDistrictUuid(data) {
  return request({
    url: URL.mdm.basicData.getTownByDistrictUuid,
    method: 'post',
    data
  })
}
